export const BENEFITS_KEY_OVERRIDES = {
  sbcUrl: 'SBCUrl',
  carrierCSN: 'CarrierCSN',
  hsaSwap: 'HSASwap',
  hsaPartialBundle: 'HSAPartialBundle',
  hsapartialBundle: 'HSAPartialBundle',
  hsaCobra: 'HSACobra',
  hsaMath: 'HSAMath',
  hraAdminFee: 'HRAAdminFee',
  bundleHSABenefits: 'BundleHSABenefits',
  vcnStatus: 'VCNStatus',
  vcn: 'VCN',
  hixmeAccidentGroupId: 'HixmeAccidentGroupId',
  pcp: 'PCP',
  pcpId: 'PCPId',
  ssn: 'SSN',
  ssnEncrypted: 'SSNEncrypted',
}
